import { Application } from "pixi.js";

export async function createApp(
  container: HTMLElement,
  width: number,
  height: number
): Promise<Application> {
  const app = new Application();
  await app.init({
    width,
    height,
    backgroundColor: 0x1a1a2e,
    antialias: true,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
  });
  // Ensure canvas fills container and resizes with it
  app.canvas.style.width = "100%";
  app.canvas.style.height = "100%";
  app.canvas.style.display = "block";
  // PixiJS defaults the canvas to touch-action:none, which swallows every
  // swipe on the board and makes the page unscrollable on phones. Allow
  // vertical pan so a swipe over the board scrolls the page; taps and
  // horizontal gestures (tile drag) still reach Pixi.
  app.canvas.style.touchAction = "pan-y";
  // Pixi also auto-preventDefaults pointer events, which would cancel the
  // browser's pan gesture even with touch-action:pan-y. Disable it so
  // vertical swipes over the board hand off to page scroll.
  const events = (app.renderer as unknown as { events?: { autoPreventDefault?: boolean } }).events;
  if (events) events.autoPreventDefault = false;
  container.appendChild(app.canvas);
  return app;
}
